export default {
  pageView: () => pageView(),
  trackEvent: (event) => trackEvent(event)
};

function pageView() {
  window.countly.q.push(['track_pageview', window.location.pathname]);
}

function trackEvent(event) {
  window.countly.q.push(['add_event',event]);
}